// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__4fhzU","title":"FrontImage_title__XENIL"};